import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { devopsConnectedProjectRoute } from '@atlassian/jira-router-routes-devops-connected-project-routes/src/devopsConnectedProjectRoute.tsx';
import DevopsConnectedProject, {
	LazyDevopsConnectedProject,
} from './ui/spa/devops/connected-project/index.tsx';

export const devopsConnectedProjectRouteEntry = createEntry(devopsConnectedProjectRoute, () => ({
	group: 'devops',
	ufoName: 'devops.connected-project',
	component: DevopsConnectedProject,
	layout: chromelessLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyDevopsConnectedProject],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-devops-connected-project-entries/src/devopsConnectedProjectRouteEntry.tsx',
			whichExportToUse: 'devopsConnectedProjectRouteEntry',
		},

		enabled: true,
	},
}));
